import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Routes that are restricted to Super Admin only
const SUPER_ADMIN_ONLY_ROUTES = [
  '/country',
  '/area',
  '/city',
  '/district',
  '/organization',
  '/branch',
  '/nationality',
  '/identity',
  '/bank',
  '/realestatetype',
  '/realestateusage',
  '/facilities-and-amenities',
  '/unit-type',
  '/unitusage',
  '/unit-facilities-amenities',
];

const AdminRoute = ({ children }) => {
  const { isAuthenticated, loading, isSuperAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        <i className="fas fa-spinner fa-spin" style={{ marginRight: '10px' }}></i>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if the current route is restricted to Super Admin only
  const isRestrictedRoute = SUPER_ADMIN_ONLY_ROUTES.some(route => 
    location.pathname.startsWith(route)
  );

  // If it's a restricted route and user is not Super Admin, redirect to dashboard
  if (isRestrictedRoute && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;

